export default function deleteLoadBalancerReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'DELETE_LOAD_BALANCER_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'DELETE_LOAD_BALANCER_ERROR':
            return {...state, ...{ error: action.error }};

        case 'DELETE_LOAD_BALANCER_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}